import { createStore } from 'vuex'

export default createStore({
  state: {
    menus: [],
    permCodes: []
  },
  getters: {
    // 判断是否有某个权限码
    hasPerm: (state) => (code) => {
      return state.permCodes.includes(code)
    }
  },
  mutations: {
    SET_MENUS(state, menus) {
      state.menus = menus
    },
    SET_PERM_CODES(state, codes) {
      state.permCodes = codes
    }
  },
  actions: {
  },
  modules: {
  }
})